export default __webpack_public_path__ + "static/media/T735_28A735B.54a8175d.STEP";